module.exports = __webpack_public_path__ + "resource/img/files.5d59ee1e.svg";